import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiConditionsSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  layout: "Grid" | "List";
}

export class ConditionsSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  layout: "Grid" | "List";
}
